import Avatar, { AVATAR_TYPE, getDisplayName } from '../../DsComponents/Avatar';
import { withCurrentUser } from '../../components/withCurrentUser';
import compose from 'recompose/compose';
import {
  SyncOutlined,
  SmileFilled,
  ClockCircleFilled,
  EyeFilled,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import LocationOn from '@material-ui/icons/LocationOn';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import {
  Divider,
  Button,
  Modal,
  ModalFuncProps,
  Input,
  Tooltip,
  Spin,
  Tag,
  Popover,
  message,
} from 'antd';
import emojiData from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import { init } from 'emoji-mart'
import { StyledButtonOutlined } from '../../DsComponents/Button';
import { EditURLsModal } from './Modals';
import {
  useDebounce,
  AppCycle,
  AvatarContainer,
  Bio,
  BioContent,
  BioIconContent,
  ContentContainer,
  HeaderContainer,
  LeftSection,
  Name,
  PreferredName,
  ProfileProps,
  RightSection,
  Location,
  Wrapper,
  Linkedin,
  Instagram,
  MyHomepage,
  Portfolio,
  TikTok,
  LeftSectionTitle,
  URLIcon,
  ProfileURLs,
  AboutMe,
  AboutTitle,
  AboutMeColumns,
  AboutMeColumn,
  AboutMeItems,
  AboutMeTypes,
  StyledCheckCircleTwoTone,
  ExperienceItem,
  ExtracurricularItem,
  ResearchItem,
  ProgramItem,
  Achievements,
  Empty,
  AchievementsList,
  HonorItem,
  AchievementCard,
  exceptEmojis,
  aboutListLeft,
  aboutListRight,
  updateEmojiListByAchievementId,
  AchievementType,
  getEmojiDataForAchievement,
  getEmojiListContainsUserId,
  ItemType,
  getTailCharS,
  EMPTY_VALUE,
  getDisplayValue,
} from './index.util';
import { useEffect, useRef, useState } from 'react';
import getInstance from '../../request';
import { createClient } from '../../shared/graphql';
import { SC_API_URI, CRIMSON_APP_API_URI, SC_BASE_URI } from '../../utils/settings';
import { LOAD_MISSION, QUERY_USER_INFO } from '../../graphql/index';
import { useParams } from "react-router-dom";
import DataProvider from '../../shared/rest';
import { ALL_STATUS, RELATION_STATUS, onAcceptOrAddClick, onSendMessage } from '../../DsComponents/FriendCardPopOver';
import { RelationButtons } from '../../DsComponents/HomeProfileCard';
import ImpactFactor from '../../DsComponents/CrImpactFactor';

init({ data: emojiData })
const SC_Client = createClient({
  endpoint: SC_API_URI,
});
const CR_Client = createClient({
  endpoint: CRIMSON_APP_API_URI,
});

const { TextArea } = Input;



declare type ConfigUpdate = ModalFuncProps | ((prevConfig: ModalFuncProps) => ModalFuncProps);

export type ModalReturnType = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  destroy: (...args: any[]) => void;
  update: (configUpdate: ConfigUpdate) => void;
};

const activeStyle = {
  background: '#464AC9',
  color: 'white',
}

const AllTabs = {
  achievements: 'achievements',
  honors: 'honors',
}

type CurrentUserType = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  country: string;
  city: string;
  name: string;
  description: string;
  profilePhoto: string;
  applicationYear: string;
  preferredName: string;
}

export const Profile = (props: ProfileProps): JSX.Element => {
  const param = useParams<{ userId: string }>();
  const { currentUser: loginUser } = props;
  const canEdit = useState(loginUser.id === param.userId)[0];
  const [activeTab, setActiveTab] = useState(AllTabs.achievements);
  const [activeEmojiPickerId, setActiveEmojiPickerId] = useState('');
  const [currentUser, setCurrentUser] = useState<CurrentUserType | undefined>(canEdit ? loginUser : undefined);
  useEffect(() => {
    async function getUserProfile(userId: string) {
      const { data } = await CR_Client.query<{
        user: {
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          country: string;
          city: string;
          name: string;
          description: string;
          profilePhoto: string;
          preferredName: string;
          studentInfo: {
            yearOfApplication: string;
          },
          roles: Array<{
            roleId: string;
            isPrimary: boolean;
          }>
        }
      }>({
        query: QUERY_USER_INFO,
        variables: {
          userId,
        },
        fetchPolicy: 'no-cache',
      });
      if (data?.user && data?.user) {
        const { studentInfo, roles, ...rest } = data?.user;
        const isStudent = roles.find(role => role.roleId === 'STUDENT')
        const applicationYear = isStudent && studentInfo?.yearOfApplication?.split('/').length > 0 ? studentInfo?.yearOfApplication?.split('/')[0] : '';
        setCurrentUser({
          ...rest,
          applicationYear,
        });
      }
    }
    if (param.userId) {
      getUserProfile(param.userId);
    }
  }, [param.userId])
  const [achievements, setAchievements] = useState<Array<AchievementType> | undefined>();
  const [refetch, setRefetch] = useState(false);
  const [urls, setURLs] = useState<ProfileURLs>({
    linkedin: '',
    instagram: '',
    tiktok: '',
    homepage: '',
    portfolio: '',
    id: '',
    userId: param?.userId,
  });
  const [aboutMe, setAboutMe] = useState<AboutMeTypes>({
    intendedMajors: '',
    bookIlove: '',
    favoriteFoods: '',
    favoriteHolidays: '',
    musicRecommendations: '',
    funFact: '',
    superpower: '',
    meaningOfName: '',
    hobbies: '',
    userId: param?.userId,
  });
  const [loading, seLoading] = useState(true);
  const [editAboutLoading, setAboutLoading] = useState(false);
  const debouncedValueAboutMe = useDebounce<AboutMeTypes>(aboutMe, 500);
  const [editKey, setEditingKey] = useState('');
  const modalRef = useRef<ModalReturnType | null>(null);
  const [buttonStatus, setButtonStatus] = useState('');
  const [relation, setRelation] = useState({ status: '', id: '' });
  useEffect(() => {
    async function getRelations() {
      const userId = loginUser.id;
      const friendId = param.userId;
      const { data } = await DataProvider.invoke('user', 'getRelations', {
        userId,
        friends: [friendId],
      });
      if (data[friendId]) {
        setRelation({ ...relation, ...data[friendId] });
        const { status } = data[friendId];
        setButtonStatus(RELATION_STATUS[status as keyof typeof RELATION_STATUS]);
      } else {
        buttonStatus === ALL_STATUS.ADD_FRIEND ||
          setButtonStatus(ALL_STATUS.ADD_FRIEND);
      }
    }
    if (loginUser.id && param.userId && loginUser.id !== param.userId) {
      getRelations();
    }
  }, [loginUser.id, param.userId]);
  useEffect(() => {
    async function fetchAchievements(userId: string) {
      const dataProvider = await getInstance();
      const { data: achievementRelatedData } = await dataProvider.get(`/usersAchievements?filter=${JSON.stringify({
        userId: param.userId,
      })}`);
      const { data } = await SC_Client.query({
        query: LOAD_MISSION,
        variables: {
          userId,
        },
        fetchPolicy: 'no-cache',
      });
      const achievements = achievementRelatedData?.data || [];
      const { experience, extracurricular, program, research, honor } = data;
      const experienceList = experience.map((item: ExperienceItem) => ({
        id: item.id,
        title: item.title,
        description: '',
        tags: [item.experience?.organizationName, item.experience?.industry].filter(value => !!value),
        supporteBy: '',
        ...getEmojiDataForAchievement({
          achievementId: item.id,
          achievements,
        }),
      }));
      const extracurricularList = extracurricular.map((item: ExtracurricularItem) => ({
        id: item.id,
        title: item.title,
        description: item.description,
        tags: [item.extracurricular?.organizationName, item.extracurricular?.activityType, item.extracurricular?.position, item.extracurricular?.hoursPerWeek && item.extracurricular?.weeksPerYear ? `${item.extracurricular?.hoursPerWeek} hr/w, ${item.extracurricular?.weeksPerYear} wk/yr` : ''].filter(value => !!value),
        supporteBy: '',
        ...getEmojiDataForAchievement({
          achievementId: item.id,
          achievements,
        }),
      }));
      const researchList = research.map((item: ResearchItem) => ({
        id: item.id,
        title: item.title,
        description: '',
        tags: [item.research?.field, item.research?.subField].filter(value => !!value),
        supporteBy: item.research?.criProgram || '',
        ...getEmojiDataForAchievement({
          achievementId: item.id,
          achievements,
        }),
      }));
      const programList = program.map((item: ProgramItem) => ({
        id: item.id,
        title: item.title,
        description: '',
        tags: [item.program?.type, item.program?.resourceCategoryName].filter(value => !!value),
        supporteBy: '',
        ...getEmojiDataForAchievement({
          achievementId: item.id,
          achievements,
        }),
      }));
      const honorList = honor.map((item: HonorItem) => ({
        id: item.id,
        title: `${item.honor?.award ? `${item.honor?.award}, ` : ''}${item.title}`,
        description: '',
        tags: [item.honor?.awardLevel, item.honor?.schoolYear.length > 0 ? `Grade ${item.honor?.schoolYear.join(',')}` : ''].filter(value => !!value),
        ...getEmojiDataForAchievement({
          achievementId: item.id,
          achievements,
        }),
      }));
      const resultList = activeTab === AllTabs.achievements ? [...experienceList, ...extracurricularList, ...researchList, ...programList] : [...honorList];
      setAchievements(resultList);
    }
    if (param?.userId && activeTab) {
      fetchAchievements(param?.userId);
    }
  }, [param, activeTab]);

  useEffect(() => {
    async function updateURLs() {
      try {
        const dataProvider = await getInstance();
        const { data: baseValue } = await dataProvider.get(`/usersProfiles?filter=${JSON.stringify({
          userId: param?.userId,
        })}`);
        const baseUserProfile = baseValue.data.length === 0 ? {} : baseValue.data[0];
        const method = baseUserProfile?.id ? 'put' : 'post';
        const restURL = `/usersProfiles${baseUserProfile?.id ? `/${baseUserProfile?.id}` : ''}`;
        const { data: result } = await dataProvider[method](restURL, baseUserProfile?.id ? 
          { ...baseUserProfile, ...debouncedValueAboutMe, updatedAt: new Date() } 
          : { ...debouncedValueAboutMe, createdAt: new Date(), updatedAt: new Date() });
        if (result?.data) {
          setAboutLoading(false);
        }
      } catch (error) {
        console.log('error:', error);
      }
    }
    if (editKey) {
      updateURLs();
    }
  }, [debouncedValueAboutMe]);

  useEffect(() => {
    async function getData() {
      const dataProvider = await getInstance();
      const { data: result } = await dataProvider.get(`/usersProfiles?filter=${JSON.stringify({
        userId: param?.userId,
      })}`);
      if (result && result.data && result.data.length > 0) {
        setURLs(urls => ({
          ...urls,
          linkedin: result.data[0]?.linkedin,
          instagram: result.data[0]?.instagram,
          tiktok: result.data[0]?.tiktok,
          homepage: result.data[0]?.homepage,
          portfolio: result.data[0]?.portfolio,
          id: result.data[0]?.id,
        }))
        setAboutMe(aboutMe => ({
          ...aboutMe,
          hobbies: result.data[0]?.hobbies || '',
          id: result.data[0]?.id,
          intendedMajors: result.data[0]?.intendedMajors || '',
          bookIlove: result.data[0]?.bookIlove || '',
          favoriteFoods: result.data[0]?.favoriteFoods || '',
          favoriteHolidays: result.data[0]?.favoriteHolidays || '',
          musicRecommendations: result.data[0]?.musicRecommendations || '',
          funFact: result.data[0]?.funFact || '',
          superpower: result.data[0]?.superpower || '',
          meaningOfName: result.data[0]?.meaningOfName || '',
        }));
      }
      seLoading(false);
    }
    if (currentUser?.id) {
      getData();
    }
  }, [currentUser, refetch]);
  const openEditURLsPopup = () => {
    if (document.getElementsByClassName('community-modal-default').length === 0) {
      modalRef.current = Modal.info({
        content: <EditURLsModal urlsDefault={urls} onClose={() => {
          setRefetch(!refetch);
          modalRef.current?.destroy();
        }} />,
        className: 'community-modal-default',
        icon: '',
        maskClosable: true,
        width: '600px',
      });
    }
  }
  const onAboutMeChange = (value: string, key: string) => {
    setAboutLoading(true);
    setEditingKey(key);
    setAboutMe(aboutMe => ({
      ...aboutMe,
      [key]: value,
    }))
  }
  const onEmojiPicked = async ({ achievementId, emoji, profileUserId, userId, userName }: { achievementId: string; emoji: string; profileUserId: string; userName?: string; userId?: string }) => {
    if (!userId || !userName) {
      return;
    }
    const dataProvider = await getInstance();
    const { data: achievementData } = await dataProvider.get(`/usersAchievements?filter=${JSON.stringify({
      userId: param.userId,
      achievementId,
    })}`);
    const baseValue = achievementData.data.length > 0 ? achievementData.data[0] : {
      userId: profileUserId,
      achievementId: achievementId,
      emojisList: {
        [emoji]: [{
          userId,
          userName,
        }]
      }
    };
    const method = baseValue?.id ? 'put' : 'post';
    const restURL = `/usersAchievements${baseValue?.id ? `/${baseValue?.id}` : ''}`;
    const baseEmojisList = baseValue?.emojisList || {};
    const result = await dataProvider[method](restURL, baseValue?.id ? {
      ...baseValue,
      emojisList: {
        ...baseEmojisList,
        [emoji]: baseEmojisList[emoji] ?
          !baseEmojisList[emoji].find((item: { userId: string }) => item.userId === userId) ?
            [...baseEmojisList[emoji], {
              userId,
              userName,
            }] :
            [...baseEmojisList[emoji].filter((item: { userId: string }) => item.userId !== userId)] : [{
              userId,
              userName,
            }],
      }
    } : baseValue);
    if (result.status === 200) {
      const { emojisList } = result?.data?.data;
      setAchievements((achievements) => (updateEmojiListByAchievementId(
        achievements || [],
        achievementId,
        emojisList,
      )));
    }
  }
  const onVisibleUpdate = async ({ achievementId, visibleToOthers, userId }: { achievementId: string; visibleToOthers: boolean; userId?: string }) => {
    if (!userId) {
      return;
    }
    const dataProvider = await getInstance();
    const { data: achievementData } = await dataProvider.get(`/usersAchievements?filter=${JSON.stringify({
      userId: param.userId,
      achievementId,
    })}`);
    const baseValue = achievementData.data.length > 0 ? achievementData.data[0] : {
      userId,
      achievementId: achievementId,
    };
    const method = baseValue?.id ? 'put' : 'post';
    const restURL = `/usersAchievements${baseValue?.id ? `/${baseValue?.id}` : ''}`;
    const result = await dataProvider[method](restURL, {
      ...baseValue,
      visibleToOthers,
    });
    if (result.status === 200) {
      const { visibleToOthers } = result?.data?.data;
      setAchievements((achievements) => {
        const index = (achievements || []).findIndex(item => item.id === achievementId);
        if (index !== -1 && achievements) {
          achievements[index] = {
            ...achievements[index],
            visibleToOthers,
          }
        }
        return [...(achievements || [])];
      });
    }
  }
  const onLikesUpdate = async ({ achievementId, userId, userName }: { achievementId: string; userId?: string; userName?: string }) => {
    if (!userId || !userName) {
      return;
    }
    const dataProvider = await getInstance();
    const { data: achievementData } = await dataProvider.get(`/usersAchievements?filter=${JSON.stringify({
      userId: param.userId,
      achievementId,
    })}`);
    const baseValue = achievementData.data.length > 0 ? achievementData.data[0] : {
      userId,
      achievementId: achievementId,
    };
    const method = baseValue?.id ? 'put' : 'post';
    const restURL = `/usersAchievements${baseValue?.id ? `/${baseValue?.id}` : ''}`;
    const result = await dataProvider[method](restURL, {
      ...baseValue,
      likes: baseValue?.likes ? baseValue?.likes?.find((item: ItemType) => item.userId === userId) ? baseValue?.likes?.filter((item: ItemType) => item?.userId !== userId) : [...baseValue?.likes, {
        userId,
        userName,
      }] : [{
        userId,
        userName,
      }],
    });
    if (result.status === 200) {
      const { likes } = result?.data?.data;
      setAchievements((achievements) => {
        const index = (achievements || []).findIndex(item => item.id === achievementId);
        if (index !== -1 && achievements) {
          achievements[index] = {
            ...achievements[index],
            likes,
          }
        }
        return [...(achievements || [])];
      });
    }
  }
  const afterAddOrAccept = () => {
    switch (buttonStatus) {
      case ALL_STATUS.ACCEPT:
        setButtonStatus(ALL_STATUS.REQUEST_ACCEPTED);
        break;
      case ALL_STATUS.ADD_FRIEND:
        setButtonStatus(ALL_STATUS.REQUEST_SENT);
        break;
      default:
        break;
    }
  };
  const onAddFriendClicked = () => {
    if ([ALL_STATUS.ACCEPT, ALL_STATUS.ADD_FRIEND].includes(buttonStatus)) {
      onAcceptOrAddClick({
        relationStatus: relation.status,
        buttonStatus,
        relationId: relation.id,
        userId: loginUser.id,
        friendId: param.userId,
        callback: afterAddOrAccept,
      });
    } else if (buttonStatus && buttonStatus === ALL_STATUS.REQUEST_ACCEPTED) {
      onSendMessage({ relation, setRelation });
    } else {
      return;
    }
  };

  const openLink = (link: string) => {
    if (link) {
      window.open(
        link,
        '_blank'
      );
    }
  }
  const routeToStudentCenter = (extra?: string) => {
    const url = `${SC_BASE_URI(param.userId || '')}${extra ? `${extra}` : ''}`;
    window.open(
      url,
      '_blank'
    );
  };
  return <Wrapper>
    <HeaderContainer>
      <img className='header-banner' src={`/img/profile/profile_banner_${Math.round(Math.random()) * 3 + 1}.png`} alt="profile banner" />
      <AvatarContainer>
        <Avatar
          type={AVATAR_TYPE.USER}
          src={currentUser?.profilePhoto}
          name={getDisplayName(currentUser)}
          style={{ width: '160px', height: '160px', fontSize: '50px' }}
          size={160}
        />
      </AvatarContainer>
    </HeaderContainer>
    <ContentContainer>
      <LeftSection>
        <Name>{currentUser?.name}{canEdit && <EditIcon
          onClick={() => routeToStudentCenter('personal-info')}
          style={{
            cursor: 'pointer',
            fontSize: '14px',
            color: '#A9ACC0',
            position: 'absolute',
            right: '0',
            transform: 'translateY(30%)',
          }}
        />}</Name>
        {/* TODO */}
        <Bio className={!currentUser?.description ? 'empty' : ''}>{getDisplayValue(currentUser?.description, EMPTY_VALUE.bio)}</Bio>
        {!canEdit && <RelationButtons
          userId={param.userId}
          buttonStyles={{
            viewProfile: {},
            addButton: {
              width: '244px',
              marginTop: '24px',
            }
          }}
          buttonVisible={{
            viewProfile: false,
            message: buttonStatus === ALL_STATUS.REQUEST_ACCEPTED,
            addFriendDisabled: ![
              ALL_STATUS.ACCEPT,
              ALL_STATUS.ADD_FRIEND,
              ALL_STATUS.REQUEST_ACCEPTED,
            ].includes(buttonStatus),
          }}
          onAddFriendClicked={onAddFriendClicked}
        />}
        <Divider />
        {currentUser?.name && <PreferredName>
          <BioIconContent>
            <SmileFilled />
          </BioIconContent>
          <BioContent style={{
            position: 'relative',
            width: '100%',
          }}>
            <p>Preferred Name</p>
            <p className="content">{getDisplayValue(currentUser?.preferredName)}</p>
            {canEdit && <EditIcon
              onClick={() => routeToStudentCenter('personal-info')}
              style={{
                cursor: 'pointer',
                fontSize: '14px',
                color: '#A9ACC0',
                position: 'absolute',
                right: '0',
                transform: 'translateY(30%)',
              }}
            />}
          </BioContent>
        </PreferredName>}
        <Location>
          <BioIconContent>
            <LocationOn style={{
              height: '16px',
            }} />
          </BioIconContent>
          <BioContent>
            <p>Location</p>
            <p className="content">
              {getDisplayValue(`${currentUser?.city || ''}${currentUser?.country && currentUser?.city ? ' ,' : ''
                }${currentUser?.country || ''}`)}</p>
          </BioContent>
        </Location>
        <AppCycle>
          <BioIconContent>
            <ClockCircleFilled />
          </BioIconContent>
          <BioContent>
            <p>App Cycle</p>
            <p className="content">{getDisplayValue(currentUser?.applicationYear)}</p>
          </BioContent>
        </AppCycle>
        <Divider />
        <LeftSectionTitle>URLs {canEdit && <EditIcon onClick={() => openEditURLsPopup()} style={{
          cursor: 'pointer',
          fontSize: '14px',
          color: '#A9ACC0',
        }} />}</LeftSectionTitle>
        <Linkedin>
          <URLIcon>
            <img className='url-icon' src="/img/profile/logo_linkedin.svg" alt="logo" />
          </URLIcon>
          <BioContent>
            <p>Linkedin</p>
            <Button onClick={() => openLink(urls.linkedin ? `https://www.linkedin.com/in/${urls.linkedin}/` : '')} className={urls.linkedin ? "content" : "content empty"} type="link" block>{urls.linkedin ? '@' : ''}{getDisplayValue(urls.linkedin)}</Button>
          </BioContent>
        </Linkedin>
        <Instagram>
          <URLIcon>
            <img className='url-icon' src="/img/profile/logo_instagram.svg" alt="logo" />
          </URLIcon>
          <BioContent>
            <p>Instagram</p>
            <Button onClick={() => openLink(urls.instagram ? `https://www.instagram.com/${urls.instagram}/` : '')} className={urls.instagram ? "content" : "content empty"} type="link" block>{urls.instagram ? '@' : ''}{getDisplayValue(urls.instagram)}</Button>
          </BioContent>
        </Instagram>
        <TikTok>
          <URLIcon>
            <img className='url-icon' src="/img/profile/logo_tiktok.svg" alt="logo" />
          </URLIcon>
          <BioContent>
            <p>TikTok</p>
            <Button onClick={() => openLink(urls.tiktok ? `https://www.tiktok.com/@${urls.tiktok}` : '')} className={urls.tiktok ? "content" : "content empty"} type="link" block>{urls.tiktok ? '@' : ''}{getDisplayValue(urls.tiktok)}</Button>
          </BioContent>
        </TikTok>
        <MyHomepage>
          <URLIcon>
            <img className='url-icon' src="/img/profile/logo_links.svg" alt="logo" />
          </URLIcon>
          <BioContent>
            <p>My homepage</p>
            <Button onClick={() => openLink(urls.homepage ? urls.homepage : '')} className={urls.homepage ? "content" : "content empty"} type="link" block>{getDisplayValue(urls.homepage)}</Button>
          </BioContent>
        </MyHomepage>
        <Portfolio>
          <URLIcon>
            <img className='url-icon' src="/img/profile/logo_links.svg" alt="logo" />
          </URLIcon>
          <BioContent>
            <p>Portfolio</p>
            <Button onClick={() => openLink(urls.portfolio ? urls.portfolio : '')} className={urls.portfolio ? "content" : "content empty"} type="link" block>{getDisplayValue(urls.portfolio)}</Button>
          </BioContent>
        </Portfolio>
      </LeftSection>
      <RightSection>
        <AboutMe>
          <AboutTitle>About Me</AboutTitle>
          <AboutMeColumns>
            <AboutMeColumn>
              {aboutListLeft.map((item) => (
                <AboutMeItems>
                  <div className='title'>
                    {item.title}
                    {editKey === item.key && editAboutLoading ?
                      <SyncOutlined
                        spin
                        style={{
                          color: '#faad14',
                          width: '20px',
                        }}
                      />
                      : <StyledCheckCircleTwoTone
                        twoToneColor="#52c41a"
                        style={{
                          marginLeft: '4px',
                        }}
                      />}
                  </div>
                  {!loading && canEdit ?
                    <TextArea
                      onChange={e => onAboutMeChange(e.target.value, item.key)}
                      autoSize
                      defaultValue={aboutMe[item.key] || ''}
                      placeholder={getDisplayValue(aboutMe[item.key], EMPTY_VALUE.enter)}
                      bordered={false}
                      maxLength={100}
                    /> :
                    <div className={aboutMe[item.key] ? 'content' : 'content empty-content'}>
                      {getDisplayValue(aboutMe[item.key], EMPTY_VALUE.toBeDefined)}
                    </div>
                  }
                </AboutMeItems>
              ))}
            </AboutMeColumn>
            <AboutMeColumn style={{
              marginLeft: '80px',
            }}>
              {aboutListRight.map((item) => (
                <AboutMeItems>
                  <div className='title'>
                    {item.title}
                    {editKey === item.key && editAboutLoading ?
                      <SyncOutlined
                        spin
                        style={{
                          color: '#faad14',
                          width: '20px',
                        }}
                      />
                      : <StyledCheckCircleTwoTone
                        twoToneColor="#52c41a"
                        style={{
                          marginLeft: '4px',
                        }}
                      />}
                  </div>
                  {!loading && canEdit ?
                    <TextArea
                      onChange={e => onAboutMeChange(e.target.value, item.key)}
                      autoSize
                      defaultValue={aboutMe[item.key] || ''}
                      placeholder={getDisplayValue(aboutMe[item.key], EMPTY_VALUE.enter)}
                      bordered={false}
                      maxLength={100}
                    />
                    : <div className={aboutMe[item.key] ? 'content' : 'content empty-content'}>
                      {getDisplayValue(aboutMe[item.key], EMPTY_VALUE.toBeDefined)}
                    </div>
                  }
                </AboutMeItems>
              ))}
            </AboutMeColumn>
          </AboutMeColumns>
        </AboutMe>
        <Achievements>
          <div className='header-title'>Achievements
            {canEdit && <div className='header-title-tooltip' onClick={() => routeToStudentCenter('activities')} >
              Edit in the Student Center
            </div>}
          </div>
          <div className='category-button-group'>
            <StyledButtonOutlined
              style={activeTab === AllTabs.achievements ? activeStyle : {}}
              onClick={() => setActiveTab(AllTabs.achievements)}
            >
              Extracurricular Activities
            </StyledButtonOutlined>
            <StyledButtonOutlined
              onClick={() => setActiveTab(AllTabs.honors)}
              style={activeTab === AllTabs.honors ? {
                ...activeStyle,
                marginLeft: '16px',
              } : { marginLeft: '16px' }}
            >
              Honors
            </StyledButtonOutlined>
          </div>
          {achievements !== undefined && achievements.length > 0 && canEdit &&
            <div className='description'>
              <EyeFilled
                style={{
                  color: '#73747D',
                  marginRight: '8px',
                  fontSize: '16px',
                }}
              />
              Make your items visible if you want to showcase your achievments to other members.
            </div>
          }
          <AchievementsList>
            {achievements === undefined ?
              <Spin spinning={achievements === undefined} delay={500}>
                <Empty />
              </Spin>
              : achievements.length > 0 ?
                <>{achievements.map(item => canEdit || item.visibleToOthers ? (
                  <AchievementCard className={item.visibleToOthers ? '' : 'unvisible'}>
                    <div className='title'>{item.title}</div>
                    {item.description && <div className='description' style={{
                      flexWrap: item.description.includes(' ') ? 'nowrap' : 'wrap',
                    }}>
                      {item.description.includes(' ') ?
                        item.description :
                        Array.from(item.description).map((char, index) => (
                          <span key={`${char}-${index}`}>{char}</span>
                        ))
                      }
                    </div>}
                    <div className='tags'>
                      {item.tags.map(tag => <Tag>
                        {tag.includes('Tier') ?
                          <ImpactFactor
                            defaultValue={tag || 0}
                            disabled={true}
                          /> :
                          tag}
                      </Tag>)}
                      {item.supporteBy &&
                        <div className='supported-link' onClick={() => openLink(`https://app.crimsoneducation.org/crimson-store/item/20642f7b-24ba-4a62-bf6e-3510010db875?from=community&userId=${param.userId}`)}>
                          <img className='supported-icon' src={`/img/profile/top-supported.svg`} alt={"supported"} />
                          Supported by
                          <div className='link'>Crimson Indigo Research</div>
                        </div>}
                    </div>
                    <Divider dashed />
                    <div className='achievements-footer'>
                      <>
                        <ThumbUpAltIcon
                          style={{
                            fontSize: '24px',
                            color: item?.likes && item?.likes.find(like => like.userId === loginUser?.id) ? '#464AC9' : '#73747D',
                            marginRight: '8px',
                          }}
                          onClick={() => {
                            onLikesUpdate({
                              achievementId: item.id,
                              userId: loginUser?.id,
                              userName: loginUser?.name,
                            })
                          }}
                        />
                        {item?.likes && item?.likes?.length > 0 &&
                          <span
                            style={{
                              color: '#464AC9',
                              fontFamily: 'Lato',
                              fontWeight: '500',
                              fontSize: '14px',
                            }}
                          >
                            {getTailCharS(item?.likes?.length, 'like')}
                          </span>
                        }
                      </>
                      {canEdit && <>
                        <Tooltip title={item?.visibleToOthers ? 'Set invisible to others' : 'Set visible to others'}>
                          <>
                            {item?.visibleToOthers ? <VisibilityIcon
                              onClick={() => {
                                onVisibleUpdate({
                                  achievementId: item.id,
                                  visibleToOthers: false,
                                  userId: loginUser?.id,
                                })
                              }}
                              style={{
                                display: 'flex',
                                fontSize: '24px',
                                color: '#464AC9',
                                marginRight: '8px',
                                marginLeft: '16px',
                                cursor: 'pointer',
                              }}
                            /> : <VisibilityOffIcon
                              onClick={() => {
                                onVisibleUpdate({
                                  achievementId: item.id,
                                  visibleToOthers: true,
                                  userId: loginUser?.id,
                                })
                              }}
                              style={{
                                display: 'flex',
                                fontSize: '24px',
                                color: '#73747D',
                                marginRight: '8px',
                                marginLeft: '16px',
                                cursor: 'pointer',
                              }}
                            />}
                          </>
                        </Tooltip>
                      </>}
                      {Object.keys(item.emojisList).filter(emoji => item.emojisList[emoji].length !== 0).map((emoji: string, index: number) => (
                        <div
                          key={emoji}
                          className={`emoji-container ${getEmojiListContainsUserId({
                            emojisList: item.emojisList,
                            userId: loginUser?.id,
                          }).includes(emoji) ? 'active' : ''}`}
                          style={index === 0 ? { marginLeft: 'auto' } : {}}
                          onClick={() => {
                            onEmojiPicked({
                              achievementId: item.id,
                              emoji,
                              profileUserId: param?.userId,
                              userId: loginUser?.id,
                              userName: loginUser?.name,
                            })
                          }}
                        >
                          <em-emoji id={emoji} size="18px"></em-emoji>
                          <span style={{ marginLeft: '6px' }}>{item.emojisList[emoji].length}</span>
                        </div>
                      ))}
                      <Popover
                        overlayInnerStyle={{
                          background: 'transparent',
                          borderRadius: '10px',
                        }}
                        destroyTooltipOnHide={true}
                        overlayClassName='profile-emoji-popover'
                        getPopupContainer={(trigger) => trigger.parentElement as HTMLElement}
                        placement="topLeft"
                        content={<Picker
                          onClickOutside={() => {
                            setActiveEmojiPickerId('');
                          }}
                          theme="light"
                          exceptEmojis={[...exceptEmojis, ...getEmojiListContainsUserId({
                            emojisList: item.emojisList,
                            userId: loginUser?.id,
                          })]}
                          data={emojiData}
                          onEmojiSelect={(e: { id: string; }) => {
                            const disabledEmojis = [...exceptEmojis, ...getEmojiListContainsUserId({
                              emojisList: item.emojisList,
                              userId: loginUser?.id,
                            })];
                            if (!disabledEmojis.includes(e.id)) {
                              onEmojiPicked({
                                achievementId: item.id,
                                emoji: e.id,
                                profileUserId: param?.userId,
                                userId: loginUser?.id,
                                userName: loginUser?.name,
                              })
                            } else {
                              message.error("You can't use this emoji!");
                            }
                            setActiveEmojiPickerId('');
                          }} />}
                        trigger={'click'}
                        open={activeEmojiPickerId === item.id}
                      >
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            setActiveEmojiPickerId(activeEmojiPickerId === item.id ? '' : item.id);
                          }}
                          className='emoji-container'
                          style={{
                            marginLeft: Object.values(item.emojisList).find(emojiItemValue => emojiItemValue.length !== 0) ? '0px' : 'auto',
                            background: item.visibleToOthers ? '#F3F6FA' : 'white',
                          }}
                        >
                          <img className='add-reaction' src={`/img/profile/add_reaction.svg`} alt={"reaction"} />
                        </div>
                      </Popover>
                    </div>
                  </AchievementCard>
                ) : null)}</>
                : null
            }
            {canEdit && achievements?.length === 0 && <Empty>
              <img className='empty-icon' src={`/img/profile/empty.svg`} alt={"empty"} />
              <div className='title'>No achievement available!</div>
              <div className='description'>Start adding your first extracurricular activities in the Student Center!</div>
              <StyledButtonOutlined
                style={{
                  marginTop: '32px',
                  background: '#464AC9',
                  color: 'white',
                }}
                onClick={() => {
                  if (param.userId) {
                    routeToStudentCenter('activities');
                  }
                }}
              >Go to Student Center</StyledButtonOutlined>
            </Empty>
            }
            {!canEdit && achievements?.filter(item => item.visibleToOthers).length === 0 && <Empty>
              <img className='empty-icon' src={`/img/profile/empty.svg`} alt={"empty"} />
              <div className='title'>No achievement available!</div>
            </Empty>}
          </AchievementsList>
        </Achievements>
      </RightSection >
    </ContentContainer >
  </Wrapper >
}

export const UserProfile = compose<ProfileProps, ProfileProps>(
  withCurrentUser,
)(Profile);